function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.505.088L3.297 3.297.088.088",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
});

function SvgDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.594 3.474"
  }, props), _ref);
}

export default SvgDropDown;